import React, { useEffect, useState, useMemo } from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useMosques, useDeleteMosque } from "api/useMosques.ts";

export default function mosquesTableData(onEditMosque, searchParams = {}) {
  const { data: fetchedMosques, isLoading } = useMosques(searchParams);
  const deleteMosqueMutation = useDeleteMosque();
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success", // "success" | "error"
  });

  const handleCloseNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  const handleDeleteMosque = async (mosqueId) => {
    try {
      await deleteMosqueMutation.mutateAsync(mosqueId);
      setNotification({
        open: true,
        message: "تم حذف المسجد بنجاح",
        severity: "success",
      });
    } catch (error) {
      console.error("Error deleting mosque:", error);
      setNotification({
        open: true,
        message: "فشل في حذف المسجد",
        severity: "error",
      });
    }
  };

  const rows = useMemo(() => {
    return isLoading
      ? Array(10)
          .fill(0)
          .map((_, index) => ({
            mosqueId: index + 1,
            mosqueName: "جاري التحميل...",
            responsibleName: "جاري التحميل...",
            mobileNumber: "جاري التحميل...",
            secondNumber: "جاري التحميل...",
            address: "جاري التحميل...",
            location: "جاري التحميل...",
            action: <div className="flex justify-center space-x-2">جاري التحميل...</div>,
          }))
      : fetchedMosques?.map((mosque) => ({
          mosqueId: mosque._id,
          mosqueName: mosque.name || "N/A",
          responsibleName: mosque.responsibleName || "N/A",
          mobileNumber: mosque.mobileNumber || "N/A",
          secondNumber: mosque.secondNumber || "-",
          address: mosque.address || "-",
          city: mosque.city || "-",
          district: mosque.district || "-",
          postalCode: mosque.postalCode || "-",
          isActive: mosque.isActive ? "نشط" : "غير نشط",
          location:
            Array.isArray(mosque.location?.coordinates) && mosque.location.coordinates.length === 2
              ? `${mosque.location.coordinates[0]}, ${mosque.location.coordinates[1]}`
              : "N/A",
          action: (
            <div className="flex justify-center space-x-2">
              <IconButton
                color="primary"
                size="medium"
                onClick={() => onEditMosque && onEditMosque(mosque)}
              >
                <EditIcon fontSize="medium" />
              </IconButton>
              <IconButton
                color="error"
                size="medium"
                onClick={() => handleDeleteMosque(mosque._id)}
                disabled={deleteMosqueMutation.isPending}
              >
                <DeleteIcon fontSize="medium" />
              </IconButton>
            </div>
          ),
        }));
  }, [isLoading, deleteMosqueMutation.isPending, onEditMosque]);

  return {
    columns: [
      { Header: "المعرف", accessor: "mosqueId", align: "center" },
      { Header: "اسم المسجد", accessor: "mosqueName", align: "center" },
      { Header: "اسم المسؤول", accessor: "responsibleName", align: "center" },
      { Header: "رقم الجوال", accessor: "mobileNumber", align: "center" },
      { Header: "الرقم الثاني", accessor: "secondNumber", align: "center" },
      { Header: "العنوان", accessor: "address", align: "center" },
      { Header: "المدينة", accessor: "city", align: "center" },
      { Header: "الحي", accessor: "district", align: "center" },
      { Header: "الرمز البريدي", accessor: "postalCode", align: "center" },
      { Header: "الحالة", accessor: "isActive", align: "center" },
      { Header: "الموقع", accessor: "location", align: "center" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],
    rows,
    notification,
    setNotification,
    handleCloseNotification,
  };
}
